import { type ComponentProps, type ElementType } from 'react'
import { useInView } from './useInView'
import { cn } from '@/lib/utils'

/**
 * Scroll-reveal wrapper: children fade/slide in the first time they enter the
 * viewport. `delay` staggers siblings. CSS handles prefers-reduced-motion
 * (content renders instantly, no transition).
 */
export function Reveal({
  as: Tag = 'div',
  delay = 0,
  className,
  children,
  ...props
}: {
  as?: ElementType
  /** Stagger delay in milliseconds. */
  delay?: number
} & ComponentProps<'div'>) {
  const { ref, inView } = useInView<HTMLDivElement>()
  return (
    <Tag
      ref={ref}
      className={cn('reveal', inView && 'revealed', className)}
      style={delay ? { '--reveal-delay': `${delay}ms` } : undefined}
      {...props}
    >
      {children}
    </Tag>
  )
}
